import { css } from 'aphrodite';
import * as React from 'react';
import type { ISupportMailbox } from '../../../queries/Support/useSupportMailboxQuery';
import { Button } from '../../../web/components-v2/Button';
import { ManageMailboxPermissionsModal } from './ManageMailboxPermissionsModal';
import { teamTabStyles as styles } from './styles/teamTabStyles';

const getFriendlyRoleName = (role: string) => (role.startsWith('Levitate:') ? role.slice('Levitate:'.length) : role);

export function TeamTabMailboxPermissionsSection({ mailbox }: { mailbox: ISupportMailbox }) {
	const [showPermissionsModal, setShowPermissionsModal] = React.useState(false);
	const allowedRoles = mailbox.allowedRoles ?? [];

	return (
		<>
			<div className={css(styles.permissionsInfo)}>
				<div className={css(styles.permissionsTitleRow)}>
					<div className={css(styles.cardSubTitle)}>Mailbox permissions</div>
					{mailbox.isRestricted && <span className={css(styles.restrictedBadge)}>Restricted</span>}
					<Button
						variant='outline'
						size='sm'
						styles={[styles.permissionsButton]}
						onClick={() => setShowPermissionsModal(true)}
					>
						Manage permissions
					</Button>
				</div>
				<div className={css(styles.permissionsDescription)}>
					Choose which internal roles can read and write tickets without joining the assignment rotation.
				</div>
				<div className={css(styles.permissionsSummary)}>
					{allowedRoles.length > 0
						? allowedRoles.map(getFriendlyRoleName).join(', ')
						: 'No internal roles have mailbox access.'}
				</div>
			</div>

			{showPermissionsModal && (
				<ManageMailboxPermissionsModal mailbox={mailbox} onClose={() => setShowPermissionsModal(false)} />
			)}
		</>
	);
}
